export default {
    'confirm-dialog': 'تأكيد الاستعادة',
    'confirm-message': 'هل أنت متأكد من أنك تريد استعادة المادة؟'
}